import React from 'react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {smallWifi} from '../../icons';
import {OtherNetworkBox} from './OtherNetworkBox';
import {ISurroundingNetwork} from '../../../../../states/connectivity-guru-data/types';
import {ITranslate} from '../../../../../services/LocalizationService';
import {observer} from 'mobx-react';

interface NetworkTabProps {
    results: ISurroundingNetwork[];
    translate: ITranslate;
    getDbmColor: (dbm: number | undefined) => string;
}

@observer
export class NetworkTab extends TechseeBaseComponent<NetworkTabProps> {
    renderInternal() {
        const {results, translate, getDbmColor} = this.props;

        return (
            <div className='tab-box-container'>
                {results && results.length > 0 && (
                    <div>
                        <div className='tab-box-icons-and-description padding-10'>
                            <div className={'icon'}>{smallWifi}</div>
                            <span> {translate('CONNECTIVITY_GURU.WIFI_SCAN.AVAILABLE_NETWORKS')} </span>
                        </div>

                        {results.map((device, idx) => (
                            <OtherNetworkBox
                                key={idx}
                                device={device}
                                getDbmColor={getDbmColor}
                                isNetworkTab={true}
                                translate={translate}
                            />
                        ))}
                    </div>
                )}
            </div>
        );
    }
}
